"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTopTagIds = exports.computeVirtualCategoriesEntries = exports.computeMarketCategoriesEntries = exports.computeCategoryMarketInfosByMarketCategoriesMap = exports.computeVirtualMarketInfosMap = exports.computeCategoryMarketInfosMap = exports.formatSystemCurrencies = exports.collectMainOutcomes = void 0;
exports.groupChildrenSportIdsByGenericSportId = groupChildrenSportIdsByGenericSportId;
const intersectionBy_1 = __importDefault(require("lodash/fp/intersectionBy"));
const mapValues_1 = __importDefault(require("lodash/fp/mapValues"));
const flow_1 = __importDefault(require("lodash/fp/flow"));
const identity_1 = __importDefault(require("lodash/fp/identity"));
const flatMap_1 = __importDefault(require("lodash/fp/flatMap"));
const keyBy_1 = __importDefault(require("lodash/fp/keyBy"));
const mapValues_2 = __importDefault(require("lodash/mapValues"));
const slices_1 = require("../../utils/@reduxjs/slices");
const outcomes_1 = require("../../utils/outcomes");
const types_1 = require("./types");
const mainOutcomes = Object.values(types_1.MainOutcomeTypes).map((mainOutcomeType) => ({
    code: mainOutcomeType,
}));
const collectMainOutcomes = (outcomeTypes) => {
    const types = (0, flow_1.default)((0, mapValues_1.default)('orderedOutcomeTypes'), (0, flatMap_1.default)(identity_1.default))(outcomeTypes);
    return (0, flow_1.default)((0, intersectionBy_1.default)('code'), (0, keyBy_1.default)('code'), (0, mapValues_1.default)('id'))(types, mainOutcomes);
};
exports.collectMainOutcomes = collectMainOutcomes;
const formatSystemCurrencies = (currencies) => {
    const currenciesWithId = currencies.map((currency) => ({
        ...currency,
        id: currency.currency.id,
    }));
    return (0, slices_1.toIdsMap)(currenciesWithId);
};
exports.formatSystemCurrencies = formatSystemCurrencies;
const computeCategoryMarketInfosMap = (marketCategories) => {
    const categoryMarketInfosMap = {};
    marketCategories.forEach((category) => {
        category.orderedMarkets.forEach((orderedMarket) => {
            if (!categoryMarketInfosMap[orderedMarket.marketId]) {
                categoryMarketInfosMap[orderedMarket.marketId] = [];
            }
            categoryMarketInfosMap[orderedMarket.marketId].push({
                categoryMarketInfo: orderedMarket,
                marketCategory: {
                    id: category.id, // Include category id for reference
                    sportIds: category.sportIds, // Include category sportIds for fast filtration according to event sport
                    sportIdsSet: new Set(category.sportIds),
                },
            });
        });
    });
    return categoryMarketInfosMap;
};
exports.computeCategoryMarketInfosMap = computeCategoryMarketInfosMap;
const computeVirtualMarketInfosMap = (categories) => {
    const virtualMarketInfosMap = {};
    categories.forEach((category) => {
        category.orderedVirtualMarkets.forEach((market) => {
            var _a, _b;
            if (!virtualMarketInfosMap[market.filteredBy.marketId]) {
                virtualMarketInfosMap[market.filteredBy.marketId] = [];
            }
            virtualMarketInfosMap[market.filteredBy.marketId].push({
                market: {
                    ...market,
                    shouldCustomizeGroupName: (0, outcomes_1.shouldCustomizeName)(market.outcomesGroup.name),
                    shouldCustomizeOutcomeName: (_b = (_a = market.outcomeCustomizations) === null || _a === void 0 ? void 0 : _a.some((el) => (0, outcomes_1.shouldCustomizeName)(el.name || el.shortName))) !== null && _b !== void 0 ? _b : false,
                },
                category,
            });
        });
    });
    return virtualMarketInfosMap;
};
exports.computeVirtualMarketInfosMap = computeVirtualMarketInfosMap;
const computeCategoryMarketInfosByMarketCategoriesMap = (marketCategories) => (0, flow_1.default)((0, keyBy_1.default)('id'), // Transform the array of categories into an object keyed by each category's id
(0, mapValues_1.default)((marketCategory) => (0, keyBy_1.default)('id', marketCategory.orderedMarkets)) // For each category, transform its orderedMarkets array into an object keyed by each market info's id
)(marketCategories);
exports.computeCategoryMarketInfosByMarketCategoriesMap = computeCategoryMarketInfosByMarketCategoriesMap;
const computeMarketCategoriesEntries = (marketCategoriesEntries) => (0, mapValues_2.default)(marketCategoriesEntries, (marketCategory) => ({
    ...marketCategory,
    orderedMarketsIds: marketCategory.orderedMarkets.map((orderedMarkets) => orderedMarkets.id),
}));
exports.computeMarketCategoriesEntries = computeMarketCategoriesEntries;
const computeVirtualCategoriesEntries = (categories) => (0, mapValues_2.default)(categories, (marketCategory) => ({
    ...marketCategory,
    orderedMarketsIds: marketCategory.orderedVirtualMarkets.map((orderedMarkets) => orderedMarkets.id),
}));
exports.computeVirtualCategoriesEntries = computeVirtualCategoriesEntries;
function groupChildrenSportIdsByGenericSportId(sports) {
    const result = {};
    for (let i = 0; i < sports.length; i += 1) {
        const sport = sports[i];
        if (sport.genericSportId !== undefined) {
            if (result[sport.genericSportId] === undefined) {
                result[sport.genericSportId] = [];
            }
            result[sport.genericSportId].push(sport.id);
        }
    }
    return result;
}
const getTopTagIds = (entityTags, topTagNames) => {
    const ids = [];
    Object.entries(entityTags).forEach(([id, tag]) => {
        if (topTagNames.includes(tag.name.toUpperCase())) {
            ids.push(+id);
        }
    });
    return ids;
};
exports.getTopTagIds = getTopTagIds;
//# sourceMappingURL=utils.js.map